"use strict";

class StationSettingsDarFMItemCtrl
{
    constructor($rootScope, $scope, $state)
    {
        this.$rootScope = $rootScope;
        this.$scope = $scope;

        this.custom_radiovis_fqdn = false;
        this.streams = {};
        this.modelTypes = {};
        this.codes = [
            'song',
            'ad',
            'news',
            'weather',
            'traffic',
            'psa',
            'show'
        ];

        this.connectedradio_types = [
            'MUS',
            'COM',
            'OTH'
        ];

        this.$rootScope.saveDisabled = false;
        this.$rootScope.saveHiden = false;

        let parentCtrl =  $scope.$parent.ctrl;

        $scope.$watch(() => {
            return parentCtrl.exportData;
        },(newVal) => {

            if(newVal) {
                this.exportData = parentCtrl.exportData;
                this.mapping = this.exportData.darfm.mappings[ $state.params.itemId ];
            }
        });

        $scope.$watch(() => {
            return parentCtrl.streams;
        },(newVal) => {

            if(newVal) {
                this.streams = parentCtrl.streams;
            }
        });

        $scope.$watch(() => {
            return parentCtrl.modelTypes;
        },(newVal) => {
            if(newVal) {
                this.modelTypes = parentCtrl.modelTypes;
            }
        });
    }
}

StationSettingsDarFMItemCtrl.$inject = ['$rootScope', '$scope', '$state'];

module.exports = StationSettingsDarFMItemCtrl;
